import { Card, Modal, Row } from 'react-bootstrap';
import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import AwpFormActionButtons from '@components/Common/AwpFormActionButtons';
import { FORM_MODE, Permissions } from '@awp/constants';
import AvalanchePathImagesService, {
  AvalanchePathImagesDTO,
} from '@components/AvalanchePathsAdmin/Images/AvalanchePathImagesService';
import { isPristine } from '@awp/helpers/UIHelper';
import AwpYesNoDialog from '@components/Common/AwpYesNoDialog';

const AvalanchePathImagesCreateModal = (props: any) => {
  const { visible, onHide, onSave, setEventErrors, ...rest } = props;
  const entity: AvalanchePathImagesDTO | undefined = undefined;

  const [show, setShow] = useState(visible);
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);

  const avalanchePathImagesService = new AvalanchePathImagesService({ mode: FORM_MODE.CREATE, entityName: 'Image' });
  const { readOnly, title, mode } = avalanchePathImagesService.crud!;

  const handleClose = () => {
    setShow(false);
    if (onHide && props.onHide instanceof Function) onHide();
  };

  const handleSave = (values: any, myProps: any) => {
    if (onSave && props.onSave instanceof Function) onSave(values, { ...myProps, setEventErrors });
  };

  return (
    <Formik
      enableReinitialize
      validateOnMount={true}
      initialTouched={{
        image: true,
      }}
      initialValues={{
        ...avalanchePathImagesService.mapInitialValues({ entity }),
      }}
      validationSchema={avalanchePathImagesService.getValidations({
        mode,
      })}
      onSubmit={handleSave}
    >
      {(props) => (
        <Modal show={show} onHide={() => handleClose()} size="lg">
          <Modal.Header closeButton>{avalanchePathImagesService.crud?.getModalTitle()}</Modal.Header>
          <Modal.Body>
            <Form>
              <Card border="light" className="page-card">
                <Card.Body>{avalanchePathImagesService.getFields({ readOnly, entity })}</Card.Body>

                <Card.Footer>
                  <Row className="my-2">
                    <AwpFormActionButtons
                      title=" "
                      mode={mode}
                      onClickCancel={handleClose}
                      permissions={[Permissions.WriteAdminTools]}
                      readOnly={readOnly}
                      isAlignLeft={true}
                      showDeleteBtn={false}
                      props={props}
                      isPristine={isPristine(props.values, avalanchePathImagesService.mapInitialValues({ entity }))}
                      entityName={undefined}
                      setMode={undefined}
                      onClickDelete={undefined}
                      onClickEdit={undefined}
                      onClickSave={() => {
                        if (props?.values.IsDefault) {
                          setShowSaveConfirm(true);
                        } else {
                          props?.submitForm();
                        }
                      }}
                    />
                  </Row>
                </Card.Footer>
              </Card>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            {showSaveConfirm && (
              <Row className="my-2">
                <AwpYesNoDialog
                  action={() => {
                    handleClose();
                    props?.submitForm();
                  }}
                  setShowYesNoConfirm={setShowSaveConfirm}
                  props={props}
                  msg={'Are you sure you want to switch the Default Image to this Image?'}
                />
              </Row>
            )}
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
  );
};

export default AvalanchePathImagesCreateModal;
